export default {
  methods: {
    __refLoaded(ref, ms) {
      return new Promise(resolve => {
        let timeConsumed = 0
        const interval = setInterval(() => {
          if (this.$refs[ref] || timeConsumed > 5000) {
            clearInterval(interval)
            resolve()
          }
          timeConsumed += ms
        }, ms)
      })
    }
  }
}
